@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

$flip-duration: 350ms;
$flip-delay: 400ms;
$split: 30%;

.digit {
    display: inline-block;
    position: relative;
    width: 1ch;
    height: 1.35em;
    color: var(--color-white);
    background-color: var(--color-monza);
    overflow: hidden;
}

.half {
    display: block;
    position: absolute;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
}

// Static layers — always visible, no animation.
.topStatic,
.bottomStatic {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    background-color: var(--color-monza);
}

.topStatic {
    clip-path: inset(0 0 calc(100% - $split) 0);
    top: 0;
}

.bottomStatic {
    clip-path: inset($split 0 0 0);
    top: 0;
}

// Animated layers
.topFlip,
.bottomFlip {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    backface-visibility: hidden;
    background-color: var(--color-monza);
}

.topFlip {
    clip-path: inset(0 0 calc(100% - $split) 0);
    transform-origin: center $split;
    animation: flip-top $flip-duration ease-in forwards;
}

.bottomFlip {
    clip-path: inset($split 0 0 0);
    transform-origin: center $split;
    animation: flip-bottom $flip-duration ease-out forwards;
    // Bottom half starts after top half begins falling.
    animation-delay: $flip-delay;
    // Start hidden (rotated away), animation brings it into view.
    transform: rotateX(90deg);
}

@keyframes flip-top {
    0% {
        transform: rotateX(0deg);
    }

    100% {
        transform: rotateX(-90deg);
    }
}

@keyframes flip-bottom {
    0% {
        transform: rotateX(90deg);
    }

    100% {
        transform: rotateX(0deg);
    }
}

// Darkened text clipped to a thin strip below the split line,
// creating the illusion of a shadow cast only on the text glyph.
// Uses mask-image to fade out like a real shadow.
.shadow,
.shadowOverlay {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    color: rgb(0 0 0 / 30%);
    clip-path: inset($split 0 calc(100% - $split - 5%) 0);
    mask-image: linear-gradient(
        to bottom,
        black $split,
        transparent calc($split + 5%)
    );
    z-index: 2;
    pointer-events: none;
}

// During flip, .shadow hides at the same moment .shadowOverlay appears.
.shadowFlipping {
    animation: shadow-hide 0ms forwards;
    animation-delay: $flip-delay;
}

// Sits on top of .shadow, starts hidden, then appears when
// the bottom flap begins — hard cut to show the new value's shadow.
.shadowOverlay {
    z-index: 3;
    visibility: hidden;
    animation: shadow-show 0ms forwards;
    animation-delay: $flip-delay;
}

@keyframes shadow-hide {
    to {
        visibility: hidden;
    }
}

@keyframes shadow-show {
    to {
        visibility: visible;
    }
}

@media (prefers-reduced-motion: reduce) {
    .topFlip,
    .bottomFlip {
        animation: none;
    }

    .shadowFlipping,
    .shadowOverlay {
        animation: none;
        visibility: visible;
    }
}

// Horizontal line across the middle to sell the split-flap look.
// Tied to $split so the visual line stays in sync with the clip-paths.
.divider {
    position: absolute;
    left: 0;
    right: 0;
    top: $split;
    height: 3px;
    transform: translateY(-50%);
    background: var(--color-monza);
    z-index: 10;
    pointer-events: none;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        height: 2px;
    }
}
